import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';
import { usePools } from '../DatabaseContext';
import ChoiceQuestion from '../Fields/ChoiceQuestion';
import FormContainer from '../Fields/FormContainer';
import NumberQuestion from '../Fields/NumberQuestion';
import SaveAndContinue from '../Fields/SaveAndContinue';

const DEFAULT_HOURS_UNCOVERED = 4;
const DEFAULT_HOURS_USED = 2;

export default function TemperaturePage({ i18n }) {
    const { id } = useParams()
    const { setPoolId, pool } = usePools()
    const [usage, setUsage] = useState('Private');
    const [hoursUncovered, setHoursUncovered] = useState(DEFAULT_HOURS_UNCOVERED)
    const [hoursUsed, setHoursUsed] = useState(DEFAULT_HOURS_USED);
    const [requiredTemperature, setRequiredTemperature] = useState(0)

    const updateFields = () => {
        setUsage(pool?.pool_usage);
        setHoursUsed(pool?.hours_used_a_day)
        setHoursUncovered(pool?.hours_left_uncovered)
        setRequiredTemperature(pool?.required_water_temperature)
    }

    const notReady = () => {
        return !(
            id &&
            pool &&
            hoursUncovered !== undefined &&
            hoursUsed !== undefined &&
            usage !== undefined &&
            requiredTemperature !== undefined
        );
    }

    useEffect(() => {
        setPoolId(id);
        updateFields();
    }, [id])

    useEffect(() => {
        updateFields();
    }, [pool])

    useEffect(() => {
        if (!notReady()) {
            if (pool?.hours_used_a_day === DEFAULT_HOURS_USED) {
                if (usage === 'Private') {
                    setHoursUsed(2)
                }

                if (usage === 'Commercial') {
                    setHoursUsed(8)
                }
            }

            if (pool?.hours_left_uncovered === DEFAULT_HOURS_UNCOVERED) {
                if (usage === 'Private') {
                    setHoursUncovered(4)
                }

                if (usage === 'Commercial') {
                    setHoursUncovered(12)
                }
            }
        }
    }, [usage])

    if (notReady()) {
        return <BubbleLoader />
    }

    return <FormContainer breadcrumb={[
        { label: pool.name, url: `/${pool.id}/name` },
        { label: i18n.dimensions.heading, url: `/${pool.id}/dimensions` },
        { label: i18n.temperature.heading },
    ]} >

        <p>{ i18n.temperature.heading }</p>

        <div className="mt-4 grid grid-cols-1 gap-4 sm:gap-8">
            <div className="flex-1">
                <NumberQuestion
                    value={ requiredTemperature }
                    onChange={ setRequiredTemperature }
                    name="required_temperature"
                    label={i18n.temperature.requiredTemperature}
                    small={true}
                    hint={i18n.temperature.requiredTemperatureHint}
                />
            </div>
            <div className="flex-1">
                <ChoiceQuestion
                    label={ i18n.temperature.usage }
                    name="usage"
                    onChange={ setUsage }
                    value={ usage }
                    options={[
                        // { label: i18n.temperature.spa, value: 'Spa' },
                        { label: i18n.temperature.private, value: 'Private' },
                        { label: i18n.temperature.commercial, value: 'Commercial' },
                    ]}
                />
            </div>
            <div className="flex-1">
                <NumberQuestion
                    value={ hoursUncovered }
                    onChange={ setHoursUncovered }
                    name="hours_uncovered"
                    label={i18n.temperature.hoursUncovered}
                    small={true}
                />
            </div>
            <div className="flex-1">
                <NumberQuestion
                    value={ hoursUsed }
                    onChange={ setHoursUsed }
                    name="hours_used_a_day"
                    label={ i18n.temperature.hoursUsed }
                />
            </div>
        </div>

        <SaveAndContinue id={ pool?.id } data={{
            pool_usage: usage,
            hours_used_a_day: hoursUsed,
            hours_left_uncovered: hoursUncovered,
            required_water_temperature: requiredTemperature,
        }} next="location" />

    </FormContainer>
}
